/*
 * @Author: songyzh
 * @Date: 2020-07-27 22:21:06
 * @LastEditors: songyzh
 * @LastEditTime: 2021-05-28 13:28:45
 */
import Login from '@/views/login';
import Layout from '@/layout';

export default [
  { path: '/', name: 'base', redirect: 'home' },
  { path: '/login', name: 'login', component: Login },
  {
    path: '/home',
    name: 'home',
    component: Layout,
    redirect: '/home/gps-point',
    children: [
      {
        path: 'gps-point',
        name: 'gps-point',
        component: () => import('@/views/gps-point')
      }
    ]
  },
  {
    path: '/in-sar',
    name: 'insar',
    component: Layout,
    redirect: '/in-sar/home',
    children: [
      {
        path: 'home',
        name: 'insar-home',
        component: () => import('@/views/in-sar')
      },
      {
        path: 'manage',
        name: 'insar-manage',
        component: () => import('@/views/in-sar/insar-manage')
      }
    ]
  },
  {
    path: '/time-seq',
    name: 'timeseq',
    component: Layout,
    redirect: '/time-seq/home',
    children: [
      {
        path: 'home',
        name: 'timeseq-home',
        component: () => import('@/views/time-seq')
      }
    ]
  },
  {
    path: '/user-manage',
    name: 'usermanage',
    component: Layout,
    redirect: '/user-manage/home',
    children: [
      {
        path: 'home',
        name: 'usermanage-home',
        component: () => import('@/views/user-manage')
      }
    ]
  },
  {
    path: '/history-data',
    name: 'historydata',
    component: Layout,
    redirect: '/history-data/home',
    children: [
      {
        path: 'home',
        name: 'history-data-home',
        component: () => import('@/views/history-data')
      }
    ]
  },
  {
    path: '/warnning-data',
    name: 'warnningdata',
    component: Layout,
    redirect: '/warnning-data/home',
    children: [
      {
        path: 'home',
        name: 'warnning-data-home',
        component: () => import('@/views/warning/warning-list')
      }
    ]
  },
  {
    path: '/warning-history',
    name: 'warninghistory',
    component: Layout,
    redirect: '/warning-history/home',
    children: [
      {
        path: 'home',
        name: 'warning-history',
        component: () => import('@/views/warning/warnning')
      }
    ]
  }
];
